<!-- Phones: a row with a small thumbnail; from sm up: a card with the thumbnail on top. -->
<a
  class="focus-visible:ring-ring w-20 shrink-0 rounded focus-visible:ring-2 focus-visible:outline-none sm:w-full"
  tabindex="-1"
  aria-hidden="true"
  [routerLink]="['/voucher-designs', design().public_id]">
  <app-design-thumbnail [design]="design()" />
</a>

<div class="flex min-w-0 flex-1 flex-col gap-2">
  <div class="min-w-0">
    <p class="truncate text-sm font-medium">{{ design().name }}</p>
    <div class="mt-1 flex flex-wrap items-center gap-1">
      <span hlmBadge variant="secondary">{{ typeLabel }}</span>
      @if (isActive()) {
        <span hlmBadge>In Verwendung</span>
      } @else {
        <app-design-issues [issues]="design().activation_issues" />
      }
    </div>
    <p hlmMuted class="mt-1 text-xs">{{ sizeLabel }}</p>
  </div>

  <div class="mt-auto flex items-center gap-2">
    <a
      hlmBtn
      variant="outline"
      size="sm"
      [routerLink]="['/voucher-designs', design().public_id]"
      [attr.aria-label]="'Design ' + design().name + ' bearbeiten'">
      <ng-icon name="lucidePencil" />
      Bearbeiten
    </a>

    <!-- Dropdown on desktop, bottom sheet on phones. -->
    <button
      hlmBtn
      variant="outline"
      size="sm"
      class="ms-auto hidden sm:inline-flex"
      [disabled]="busy()"
      [hlmDropdownMenuTrigger]="actionsMenu"
      align="end"
      [attr.aria-label]="'Aktionen für ' + design().name">
      <ng-icon name="lucideEllipsis" />
    </button>

    <hlm-sheet
      side="bottom"
      class="ms-auto sm:hidden"
      [state]="sheetOpen() ? 'open' : 'closed'"
      (stateChanged)="sheetOpen.set($event === 'open')"
      (closed)="runPendingAction()">
      <button
        hlmSheetTrigger
        hlmBtn
        variant="outline"
        size="sm"
        [disabled]="busy()"
        [attr.aria-label]="'Aktionen für ' + design().name">
        <ng-icon name="lucideEllipsis" />
      </button>
      <hlm-sheet-content
        *hlmSheetPortal
        class="max-h-[85vh] gap-2 overflow-y-auto rounded-t-xl px-2 pt-2 pb-[max(1rem,env(safe-area-inset-bottom))]">
        <div hlmSheetHeader class="px-3 pe-12">
          <h2 hlmSheetTitle class="truncate">{{ design().name }}</h2>
          <p hlmSheetDescription>{{ typeLabel }}</p>
        </div>
        <nav class="flex flex-col">
          <button
            hlmBtn
            variant="ghost"
            class="h-12 justify-start gap-3 text-base"
            [disabled]="isActive() || !activatable"
            (click)="chooseAction(onActivate)">
            <ng-icon name="lucideCircleCheck" />
            {{ activateLabel }}
          </button>
          <button
            hlmBtn
            variant="ghost"
            class="h-12 justify-start gap-3 text-base"
            (click)="chooseAction(onCopySame)">
            <ng-icon name="lucideCopy" />
            Duplizieren
          </button>
          <button
            hlmBtn
            variant="ghost"
            class="h-12 justify-start gap-3 text-base"
            (click)="chooseAction(onCopyOther)">
            <ng-icon name="lucideCopyPlus" />
            {{ copyLabel }}
          </button>
          <div hlmSeparator class="my-1"></div>
          <button
            hlmBtn
            variant="ghost"
            class="text-destructive hover:text-destructive hover:bg-destructive/10 h-12 justify-start gap-3 text-base"
            [disabled]="isActive()"
            (click)="chooseAction(onDelete)">
            <ng-icon name="lucideTrash2" />
            Löschen
          </button>
        </nav>
      </hlm-sheet-content>
    </hlm-sheet>
  </div>
</div>

<ng-template #actionsMenu>
  <hlm-dropdown-menu class="w-64">
    <hlm-dropdown-menu-group>
      <button hlmDropdownMenuItem [disabled]="isActive() || !activatable" (click)="onActivate()">
        <ng-icon name="lucideCircleCheck" />
        {{ activateLabel }}
      </button>
    </hlm-dropdown-menu-group>
    <div hlmDropdownMenuSeparator></div>
    <hlm-dropdown-menu-group>
      <button hlmDropdownMenuItem (click)="onCopySame()">
        <ng-icon name="lucideCopy" />
        Duplizieren
      </button>
      <button hlmDropdownMenuItem (click)="onCopyOther()">
        <ng-icon name="lucideCopyPlus" />
        {{ copyLabel }}
      </button>
    </hlm-dropdown-menu-group>
    <div hlmDropdownMenuSeparator></div>
    <button hlmDropdownMenuItem variant="destructive" [disabled]="isActive()" (click)="onDelete()">
      <ng-icon name="lucideTrash2" />
      Löschen
    </button>
  </hlm-dropdown-menu>
</ng-template>
